import * as React from 'react'

function SvgCf(props) {
	return (
		<svg viewBox="0 0 450 300" width="1em" height="1em" {...props}>
			<path fill="#FFCE00" d="M0 0h450v300H0z" />
			<path fill="#289728" d="M0 0h450v225H0z" />
			<path fill="#FFF" d="M0 0h450v150H0z" />
			<path fill="#003082" d="M0 0h450v75H0z" />
			<path fill="#D21034" d="M187.5 0h75v300h-75z" />
			<path
				fill="#FFCE00"
				d="M75.028 7.004L94.9 67.996 42.902 30.333h64.197L55.1 67.996 75.028 7.004z"
			/>
		</svg>
	)
}

export default SvgCf
